import React from 'react';
import { Mic2, BookOpen, Users, Trophy } from 'lucide-react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <Mic2 className="w-6 h-6" data-id="element-157" />,
    title: t('solution', 'f1Title'),
    desc: t('solution', 'f1Desc')
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-158" />,
    title: t('solution', 'f2Title'),
    desc: t('solution', 'f2Desc')
  }, {
    icon: <Users className="w-6 h-6" data-id="element-159" />,
    title: t('solution', 'f3Title'),
    desc: t('solution', 'f3Desc')
  }, {
    icon: <Trophy className="w-6 h-6" data-id="element-160" />,
    title: t('solution', 'f4Title'),
    desc: t('solution', 'f4Desc')
  }];
  return <Section background="charcoal" id="solution" data-id="element-161">
      <div ref={ref} className={`flex flex-col md:flex-row items-center gap-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-162">
        {/* Image Side */}
        <div className="w-full md:w-1/2 relative" data-id="element-163">
          <div className="absolute inset-0 bg-brand-blue rounded-2xl rotate-3 opacity-10 blur-sm" data-id="element-164"></div>
          <div className="relative bg-gradient-to-br from-slate-100 to-slate-200 border border-slate-200 rounded-2xl p-2 shadow-2xl" data-id="element-165">
            <img src="https://images.unsplash.com/photo-1590602847861-f357a9332bbc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Micrófono profesional en estudio" className="rounded-xl w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-166" />
            {/* Badge */}
            <div className="absolute -bottom-6 -right-6 bg-brand-blue text-white font-heading font-bold text-xl px-6 py-4 rounded-lg shadow-lg rotate-[-5deg] border-4 border-white" data-id="element-167">
              {t('solution', 'badge')}
            </div>
          </div>
        </div>

        {/* Content Side */}
        <div className="w-full md:w-1/2" data-id="element-168">
          <h3 className="text-brand-blue-light font-bold tracking-widest uppercase mb-2" data-id="element-169">
            {t('solution', 'subtitle')}
          </h3>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-6 leading-tight" data-id="element-170">
            {t('solution', 'title1')} <br data-id="element-171" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-blue to-brand-blue-light" data-id="element-172">
              {t('solution', 'title2')}
            </span>
          </h2>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-173">
            {t('solution', 'desc')}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-174">
            {features.map((feature, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-175">
                <div className="w-10 h-10 rounded-full bg-brand-blue/10 flex items-center justify-center text-brand-blue shrink-0" data-id="element-176">
                  {feature.icon}
                </div>
                <div data-id="element-177">
                  <h4 className="font-bold text-brand-navy mb-1" data-id="element-178">
                    {feature.title}
                  </h4>
                  <p className="text-sm text-slate-500" data-id="element-179">{feature.desc}</p>
                </div>
              </div>)}
          </div>

          <a href={t('hero', 'ctaLink')} target="_blank" rel="noopener noreferrer" data-id="element-180">
            <Button variant="primary" size="lg" withIcon data-id="element-181">
              {t('solution', 'cta')}
            </Button>
          </a>
        </div>
      </div>
    </Section>;
}